import React from "react";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";

const AdminRoute = ({ component: Component, path, admin, exact }) => (
  <Route
    path={path}
    exact={exact}
    render={props => (!admin ? <Redirect to="/" /> : <Component {...props} />)}
  />
);

const mapStateToProps = state => ({
  admin: Boolean(state.user.currentUser.currentUser.admin)
});

export default connect(mapStateToProps)(AdminRoute);
